import { render, staticRenderFns } from "./PreviewPdf.vue?vue&type=template&id=04be3340&scoped=true"
import script from "./PreviewPdf.vue?vue&type=script&lang=ts"
export * from "./PreviewPdf.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PreviewPdf.vue?vue&type=style&index=0&id=04be3340&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "04be3340",
  null
  ,true
)

export default component.exports